import React, { useState } from "react";
import dayjs from "dayjs";
import ChartList from "./chat/chartlist";
import PersonalChat from "./chat/personalchart";
import NewsFeed from "./chat/newsfeed";
import { homeIcon } from "../customsidenav/svgslist";

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function Messaging({ onClose }) {
  const [chatPatientId, setChatPatientId] = useState("");
  const [chatToggleScreen, setChatToggleScreen] = useState(true);
  const [chatSelectedDate, setChatSelectedDate] = useState(dayjs());
  const [isNewPatient, setIsNewPatient] = useState(false);
  const [otherViews, setOtherViews] = useState("");

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col bg-[#F5F7FA]">
      {/* Top Bar */}

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar - Chat List */}
        <div className="w-[30%] min-w-[340px] max-w-[420px] flex flex-col bg-white border-r border-[#E5E7EB]">
          <div className="flex items-center justify-between px-4 h-[62px] bg-white ">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-[#E17954] flex items-center justify-center">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <h1 className="text-[#1D2951] text-[14px] font-semibold">
                Messaging
              </h1>
            </div>
            <button
              onClick={() => onClose?.()}
              className="w-7 h-7 rounded-md flex items-center justify-center text-[#9CA3AF] hover:text-[#fff] hover:bg-[#1D2951] transition-all"
              title="Close"
            >
              {homeIcon}
            </button>
          </div>
          <div
            className="flex-1 overflow-y-auto"
            style={{ scrollbarWidth: "none" }}
          >
            <ChartList
              isNewPatient={isNewPatient}
              setIsNewPatient={setIsNewPatient}
              selectedDate={chatSelectedDate}
              setOtherViews={setOtherViews}
              otherviews={otherViews}
              setSelectedDate={setChatSelectedDate}
              setPatientId={setChatPatientId}
              patient={chatPatientId}
              setToggleScreen={setChatToggleScreen}
            />
          </div>
        </div>

        {/* Right Panel - Chat Area */}
        <div className="flex-1 flex flex-col bg-white overflow-hidden">
          {chatPatientId && Object.keys(chatPatientId).length > 0 ? (
            <div className="flex flex-col h-full">
              {otherViews === "newsfeed" ? (
                <NewsFeed
                  isNewPatient={isNewPatient}
                  setchat={() => {}}
                  otherviews={otherViews}
                  setOtherViews={setOtherViews}
                  patient={chatPatientId}
                  setToggleScreen={setChatToggleScreen}
                />
              ) : (
                <PersonalChat
                  isNewPatient={isNewPatient}
                  top="inline"
                  setchat={() => {}}
                  patient={chatPatientId}
                  setToggleScreen={setChatToggleScreen}
                />
              )}
            </div>
          ) : otherViews === "newsfeed" ? (
            <div className="flex flex-col h-full">
              <NewsFeed
                isNewPatient={isNewPatient}
                setchat={() => {}}
                otherviews={otherViews}
                setOtherViews={setOtherViews}
                patient={chatPatientId}
                setToggleScreen={setChatToggleScreen}
              />
            </div>
          ) : (
            /* Empty state - no chat selected */
            <div className="flex flex-col items-center justify-center h-full text-center px-8 bg-[#FAFBFC]">
              <div className="w-[340px] flex flex-col items-center gap-5">
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#FFF3EF] to-[#FFE4DA] flex items-center justify-center shadow-sm">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#E17954"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    <path d="M8 10h.01" />
                    <path d="M12 10h.01" />
                    <path d="M16 10h.01" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-[#1D2951] text-[22px] font-semibold mb-2">
                    Start a Conversation
                  </h2>
                  <p className="text-[#9CA3AF] text-[13px] leading-relaxed">
                    Select a patient from the left panel
                    <br />
                    to begin messaging.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
